import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { DetailsType } from '../../../../../../common/details-list/interface';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';
import { convertSecondsToTimeFormat } from '../../../../../../../constants/helpers/dates';

import { Operation } from './interfaces';

interface Props {
  operation: Operation;
  detailsType: DetailsType;
}

const SuccessOperation = ({ operation, detailsType }: Props) => {
  const theme = useTheme();
  const {
    duration,
    msisdn,
    shortcode,
    operator,
    sessionType,
    sessionTag,
    sessionCloseReason,
    sessionAbortReason,
    dialedShortcodeString
  } = operation;
  const items = [
    { label: locales.operation.label.duration, value: convertSecondsToTimeFormat(duration) },
    { label: locales.operation.label.operatorName, value: operator },
    {
      label: locales.operation.label.phoneNumber,
      value: detailsValueFormatter(msisdn)
    },
    { label: locales.operation.label.shortcode, value: shortcode },
    { label: locales.operation.label.sessionType, value: sessionType },
    { label: locales.operation.label.sessionTag, value: sessionTag },
    { label: locales.operation.label.sessionCloseReason, value: sessionCloseReason }
  ];

  if (dialedShortcodeString != null) {
    items.push({ label: locales.operation.label.dialedShortcodeString, value: dialedShortcodeString });
  }
  if (sessionAbortReason != null) {
    items.push({ label: locales.operation.label.sessionAbortReason, value: sessionAbortReason });
  }

  return (
    <DetailsFactory
      detailsType={detailsType}
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={<DetailsList items={items} />}
    />
  );
};

export default SuccessOperation;
